import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import React from 'react';

import * as notificationInterfaces from './interfaces';
import { useStyles } from '../styles';
import NotificationInfo from './Info/NotificationInfo';
import NotificationsList from './Info/NotificationsList';

//The parent component, a literal container for Channels List and Channels View

const Notifications = (props: notificationInterfaces.INotificationsProps) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Grid className={classes.contentWrapper} container justify="space-between" spacing={10}>
                <NotificationsList {...props} />
                <NotificationInfo />
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(Notifications);
